<template lang='pug'>
.mainWrapper-innerContent
  .mainWrapper-leftContent.mainWrapper-leftContent--fullWidth
    BreadCrumb(:title='data.partnerMain.title' :breadcrumbList='breadcrumbList' normal)
    PartnerArticle(:staticData='data' :params="params")
</template>
<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue'
import PartnerArticle from '@/components/public_article/partner_article.vue'

export default {
  components: {
    BreadCrumb,
    PartnerArticle
  },
  props: {
    data: Object,
    breadcrumbList: Array
  },
  data() {
    return {
      params: {
        "size": 12,
        "sort": {
          "updatedAt": {
            "dir": "desc",
            "default": true
          }
        },
        "type": "all"
      }
    }
  }
}
</script>
<style>
span {
  word-break: break-all;
}
</style>
